<template>
  <mdb-container>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="Data Importer"/>
    </div>
    <mdb-card v-if="errors">
      <mdb-card-header class="primary-color text-white">
        <h3>File Errors</h3>
      </mdb-card-header>
      <mdb-card-body>
        <div v-for="(e,i) in errors" :key="i" class="text-left">
          {{e}}
        </div>
        <mdb-btn @click="errors = null">Clear Errors</mdb-btn>
      </mdb-card-body>
    </mdb-card>
    <div v-if="importList && currentGroup" class="text-left">
      <div v-if="importList.length == 0">
        <h3>No data imports defined for {{currentGroup.name}}</h3>
      </div>
      <mdb-tbl v-if="importList.length>0" class="text-left" responsive striped>
        <mdb-tbl-head class="primary-color text-white">
          <tr>
            <th>Import Name</th>
            <th>&nbsp;</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="imp in importList" :id="'imp-'+imp.id" :key="imp.id">
            <td><h5>{{ imp.description }}</h5></td>
            <td>
              <mdb-btn @click="chooseFile(imp)" icon="upload">Upload</mdb-btn>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
    <mdb-modal v-if="uploadModal" @close="uploadModal = false">
      <mdb-modal-header class="secondary-color text-white">
        <h5>Upload File</h5>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-file-input v-on:getValue="upload"/>
      </mdb-modal-body>
    </mdb-modal>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';


export default {
  name: "group-data-importer",
  order: 1,
  components: {
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbIcon,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    bannerSmall,
    mdbFileInput,
    mdbModal,
    mdbModalHeader,
    mdbModalBody
  },
  computed: {
    currentGroup() {
      return this.$store.state.currentGroup
    }
  },
  data() {
    return {
      importList: null,
      importSelected: null,
      uploadModal: false,
      errors: null
    }
  },
  mounted() {
    document.title = "Data Importer"
    this.$store.dispatch("setExecuting", true)
    api.get("/import/list/" + this.$route.params.id).then(
      (results) => {
        this.importList = results.data.imports;
        if (!this.currentGroup || this.currentGroup.id != results.data.groupId) {
          api.groupBasics(results.data.groupId, "public");
        }
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 20000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    chooseFile(imp) {
      this.importSelected = imp
      this.uploadModal = true
    },
    upload(file) {
      this.uploadModal = false
      this.$store.dispatch("setExecuting", true)
      let url = "/import/upload/" + this.importSelected.id
      api.postFile(url, file[0]).then(
        (results) => {
          this.errors = results.data.errors
          this.$notify.success({message: "File processed successfully.", timeOut: 5000})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

}
;

</script>

